import Header from "./_components/Header";
import Hero from "./_components/Hero";
import About from "./_components/About";
import Features from "./_components/Features";
import ExploreBlockchain from "./_components/ExploreBlockchain";
import WhyItMatters from "./_components/WhyItMatters";
import GovernmentVision from "./_components/GovernmentVision";
import Footer from "./_components/Footer";

export default function Index() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Hero />
      <About />
      <Features />
      <ExploreBlockchain />
      <WhyItMatters />
      <GovernmentVision />
      <Footer />
    </div>
  );
}